import React, { useCallback } from "react";

import Button from "../ui/Button";
import logoutAction from "./../../../state/actions/ClientActions/logoutAction";
import { useDispatch } from "react-redux";

const LogoutButton: React.FC = () => {
    const dispatch = useDispatch();
    const logout = useCallback(() => dispatch(logoutAction()), [dispatch]);
    return (
        <Button light uppercase shadow onClick={() => logout()}>
            Esci
        </Button>
    );
};

export default LogoutButton;
